import { usePersistedState } from "@/lib/persisted-state";

function generateKey() {
  return `aivory_live_sk_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}

export default function ApiKeys() {
  const { value, setValue, statusLabel } = usePersistedState("workspace.apiKeys", {
    keys: [{ id: "k_1", name: "Default live key", value: "aivory_live_sk_••••••••••••••", createdAt: new Date().toISOString() }],
  });
  const keys = Array.isArray(value?.keys) ? value.keys : [];

  const rotate = (id) =>
    setValue((prev) => ({
      ...prev,
      keys: (Array.isArray(prev.keys) ? prev.keys : []).map((k) =>
        k.id === id ? { ...k, value: generateKey(), createdAt: new Date().toISOString() } : k,
      ),
    }));

  const addKey = () =>
    setValue((prev) => ({
      ...prev,
      keys: [...(Array.isArray(prev.keys) ? prev.keys : []), { id: `k_${Date.now()}`, name: "New key", value: generateKey(), createdAt: new Date().toISOString() }],
    }));

  return (
    <div className="p-8 lg:p-12 max-w-[1100px] mx-auto" data-testid="api-keys-page">
      <div className="text-overline">Workspace · API keys</div>
      <h1 className="font-heading text-4xl mt-2 tracking-tight font-medium">API keys</h1>
      {statusLabel ? <div className="text-xs text-[var(--text-secondary)] font-mono mt-2">{statusLabel}</div> : null}

      <button className="btn-primary mt-6" type="button" onClick={addKey}>Create key</button>
      <div className="mt-6 surface">
        <table className="w-full text-sm">
          <thead className="border-b border-[var(--border-default)] text-[var(--text-tertiary)] font-mono text-[10px] uppercase tracking-widest">
            <tr>
              <th className="p-4 text-left">Name</th>
              <th className="p-4 text-left">Key</th>
              <th className="p-4 text-left">Created</th>
              <th className="p-4 text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {keys.map((k) => (
              <tr key={k.id} className="border-b border-[var(--border-default)]">
                <td className="p-4">{k.name}</td>
                <td className="p-4 font-mono text-xs break-all">{k.value}</td>
                <td className="p-4 font-mono text-xs">{new Date(k.createdAt || "").toLocaleString()}</td>
                <td className="p-4 text-right">
                  <button className="btn-secondary text-xs" type="button" onClick={() => rotate(k.id)}>
                    Rotate
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
